module.exports = __webpack_public_path__ + "static/img/lj-pub-logo-market.6593c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileimg/lj-pub-logo-market.png
// module id = g1YL
// module chunks = 22